import { HttpResult } from 'widgets-for-react'
import { FooterItem } from './footerState'
import i18next from 'i18next'

export function getFooter(): Promise<HttpResult<Array<FooterItem>>> {
  const language = i18next.language
    return fetch(`/api/v1/sharepoint/footer`).then(resonse => {
      if (resonse.ok) {
        return resonse.json()
      }
      return Promise.reject(resonse)
    })
      .then(json => json as Array<FooterItem>)
      .then(menuItems => ({ status: 200, value: menuItems, kind: 'result' }))
  }

export async function submitSubscription(email: string): Promise<HttpResult<undefined>> {
  let result = await fetch(`/api/v1/HubSpot/subscribeToNewsletter`, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({"email": email, "languageCode": i18next.language || "en"}) 
  })

  if (result.ok) {
    return ({ kind: 'result', status: 200, value: undefined });
  } else {
    return ({ kind: 'failed', status: 500 });
  }
}